import { Button } from "@/components/ui/button";
import { NavLink } from "./NavLink";
import { ServiceMenu } from "./ServiceMenu";
import { navigationConfig } from "@/config/navigation";
import { Link } from "@/lib/router-compat";
import { Phone, ArrowRight } from "lucide-react";

export function DesktopNav() {
  return (
    <nav className="hidden items-center gap-7 md:flex">
      <NavLink to="/">Inicio</NavLink>
      <ServiceMenu
        trigger={navigationConfig.seoServices.title}
        services={navigationConfig.seoServices.services}
      />
      <ServiceMenu
        trigger={navigationConfig.otherServices.title}
        services={navigationConfig.otherServices.services}
      />
      <ServiceMenu
        trigger={navigationConfig.seoTools.title}
        services={navigationConfig.seoTools.services}
      />
      <NavLink to="/blog">Conocimiento</NavLink>

      <span aria-hidden="true" className="h-5 w-px bg-border" />

      <a
        href="tel:+34910626684"
        className="group hidden items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground lg:flex"
      >
        <Phone className="h-3.5 w-3.5 text-premium-gold" aria-hidden="true" />
        910 62 66 84
      </a>

      <Button
        asChild
        className="group h-10 rounded-full bg-gradient-to-r from-seo-blue to-seo-cyan px-5 text-sm font-semibold shadow-lg shadow-primary/25 transition-all duration-300 hover:shadow-xl hover:shadow-primary/40"
      >
        <Link to="/agenda-consultoria">
          Agenda tu diagnóstico
          <ArrowRight className="ml-1.5 h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
        </Link>
      </Button>
    </nav>
  );
}
